// import { TeamOutlined } from '@ant-design/icons';

// import { Page } from '@app/components';
// import {
//   DATA_TESTID_ATTRIBUTE,
//   NO_TOOLTIP_TITLE,
//   RIGHTS_CLIENTS,
// } from '@app/constants';
// import { NewClientsList } from '@app/pages/Clients/NewClientsList';
// import { NewClientsListProvider } from '@app/pages/Clients/NewClientsList/context/NewClientsListProvider';
// import {
//   NEW_CLIENTS,
//   NEW_CLIENTS_LABEL,
//   NEW_CLIENTS_PATH,
// } from '@app/routes/pages/clientsPages/constants';
import type { NNavigation } from '@app/types';

export const clientsPages: NNavigation.Main = [
  // {
  //   key: NEW_CLIENTS,
  //   icon: <TeamOutlined />,
  //   label: NEW_CLIENTS_LABEL,
  //   [DATA_TESTID_ATTRIBUTE]: NEW_CLIENTS,
  //   pagebreadcrumbdatatestid: 'clients-page',
  //   pagetitledatatestid: 'clients-title',
  //   id: NEW_CLIENTS,
  //   path: NEW_CLIENTS_PATH,
  //   title: NO_TOOLTIP_TITLE,
  //   element: (
  //     <NewClientsListProvider>
  //       <Page headerContent={<NewClientsList.Header />}>
  //         <NewClientsList.Page />
  //       </Page>
  //     </NewClientsListProvider>
  //   ),
  //   servicerightsid: RIGHTS_CLIENTS,
  //   issidebaritem: 'true',
  //   sidebarparentid: NEW_CLIENTS,
  // },
];
